export const Metrics = {
  px1: '4px',
  px2: '8px',
  px3: '12px',
  px4: '16px',
  px5: '20px',
  px6: '24px',
  px7: '28px',
  px8: '32px',
  px9: '36px',
  px10: '40px',
  px11: '44px',
  px12: '48px',

  pxS: '8px',
  pxM: '24px',
  pxL: '36px',
  pxXL: '48px',

  mobile: '568px',
  tablet: '768px',
  desktopM: '1280px',
  desktopL: '1920px'
  };

export default Metrics;
  
